import React, { useState, useRef } from 'react';
import api from '../services/api';

export default function ImageUploader({ value, onChange, label = 'Imagem' }) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const [preview, setPreview] = useState(value || '');
  const inputRef = useRef();

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Local preview imediato
    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);
    setError('');
    setUploading(true);

    try {
      const formData = new FormData();
      formData.append('image', file);

      const res = await api.post('/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      onChange(res.data.url);
      setPreview(res.data.url);
    } catch (err) {
      setError('Erro no upload: ' + (err.response?.data?.error || err.message));
      setPreview(value || '');
    } finally {
      setUploading(false);
    }
  };

  const handleRemove = () => {
    setPreview('');
    onChange('');
    if (inputRef.current) inputRef.current.value = '';
  };

  return (
    <div style={styles.container}>
      <label style={styles.label}>{label}</label>

      {preview ? (
        <div style={styles.previewContainer}>
          <img src={preview} alt="preview" style={styles.preview} />
          <div style={styles.previewActions}>
            <button type="button" style={styles.changeBtn} onClick={() => inputRef.current.click()}>
              🔄 Trocar imagem
            </button>
            <button type="button" style={styles.removeBtn} onClick={handleRemove}>
              🗑️ Remover
            </button>
          </div>
        </div>
      ) : (
        <div
          style={styles.dropZone}
          onClick={() => inputRef.current.click()}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => {
            e.preventDefault();
            const file = e.dataTransfer.files[0];
            if (file) {
              inputRef.current.files = e.dataTransfer.files;
              handleFile({ target: { files: e.dataTransfer.files } });
            }
          }}
        >
          {uploading ? (
            <div style={styles.uploading}>
              <div style={styles.spinner} />
              <span>Enviando...</span>
            </div>
          ) : (
            <>
              <span style={styles.dropIcon}>📷</span>
              <span style={styles.dropText}>Clique ou arraste uma imagem aqui</span>
              <span style={styles.dropHint}>JPG, PNG, WEBP até 10MB</span>
            </>
          )}
        </div>
      )}

      {uploading && preview && (
        <div style={styles.uploadingOverlay}>⏳ Enviando para o servidor...</div>
      )}

      {error && <p style={styles.error}>{error}</p>}

      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp,image/gif"
        style={{ display: 'none' }}
        onChange={handleFile}
      />
    </div>
  );
}

const styles = {
  container: { marginBottom: 16 },
  label: { display: 'block', fontSize: 13, color: '#555', fontWeight: '600', marginBottom: 8 },

  dropZone: {
    border: '2px dashed #d0d5dd',
    borderRadius: 12,
    padding: '32px 20px',
    textAlign: 'center',
    cursor: 'pointer',
    backgroundColor: '#fafafa',
    transition: 'border-color 0.2s, background 0.2s',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 6,
  },
  dropIcon: { fontSize: 36 },
  dropText: { fontSize: 14, color: '#444', fontWeight: '600' },
  dropHint: { fontSize: 12, color: '#aaa' },

  uploading: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 },
  spinner: {
    width: 28, height: 28,
    border: '3px solid #eee',
    borderTop: '3px solid #E63946',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  },

  previewContainer: { position: 'relative' },
  preview: {
    width: '100%', maxHeight: 220,
    objectFit: 'cover',
    borderRadius: 10,
    display: 'block',
    border: '1px solid #eee',
  },
  previewActions: { display: 'flex', gap: 8, marginTop: 8 },
  changeBtn: {
    flex: 1, padding: '8px 0', background: '#f0f2f5',
    border: 'none', borderRadius: 8, cursor: 'pointer',
    fontSize: 13, fontWeight: '600', color: '#333',
  },
  removeBtn: {
    flex: 1, padding: '8px 0', background: '#fff0f0',
    border: 'none', borderRadius: 8, cursor: 'pointer',
    fontSize: 13, fontWeight: '600', color: '#E63946',
  },

  uploadingOverlay: {
    marginTop: 6, fontSize: 13, color: '#888', textAlign: 'center',
  },
  error: { color: '#E63946', fontSize: 13, marginTop: 6 },
};
